export default __webpack_public_path__ + "static/media/misc-closetA-2048w.0553f165.webp";